import styles from "./FootnotePreview.module.scss";

interface FootnotePreviewProps {
  previewText: string;
}

export function FootnotePreview({ previewText }: FootnotePreviewProps) {
  return <div className={styles.preview}>{previewText}</div>;
}
